module.exports = __webpack_public_path__ + "assets/img/drawItem8-eaf6a848.png";